const schema = () => ({
  type: "object",
  required: [],
  properties: {
    doctor_ids: {
      type: "array",
      title: "پزشک ها",
      items: {
        type: "string",
      },
    },
    lab_ids: {
      type: "array",
      title: "لابراتوار ها",
      items: {
        type: "string",
      },
      // minItems: 2,
      // maxItems: 5
    },
  },
});

export default schema;
